export default "__VITE_ASSET__XF9dUonJ__"